import { PrimaryDefaultButton } from '@/components/buttons/primary';
import Link from '@/components/Link';
import { ModuleCtaFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { COLORS } from '@/styles/color';
import { hexToRGBA } from '@/styles/color/utils';
import { FC } from 'react';
import styled from 'styled-components';

interface CTAModuleProps {
  props: CraftModuleFragment<ModuleCtaFragment>;
}

const CTAModule: FC<CTAModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const singleCta = getSingleLink(props.primaryCta);

  if (!singleCta) return null;

  return (
    <Wrapper>
      <Link href={singleCta.url}>
        <CTA as="a">{singleCta.text}</CTA>
      </Link>
    </Wrapper>
  );
};

export default CTAModule;

// Styled Components

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CTA = styled(PrimaryDefaultButton)`
  --button-color: ${COLORS.RED.LOWLIGHT};
  --button-text-color: ${COLORS.WHITE};

  box-shadow: 0px 0px 20px ${hexToRGBA(COLORS.RED.LOWLIGHT, 0)};

  &:hover {
    box-shadow: 0px 0px 20px ${hexToRGBA(COLORS.RED.LOWLIGHT, 0.6)};
  }
`;
